import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import RBAC from 'common/rbac/RBAC';
import { mapComponentToResource, operations } from 'common/rbac/constants';
import { GhostBtn } from 'common/components/molecules/ListToolbar';
import { Download, UploadIcon } from 'common/images/FaIcons';
import ConnectedExportModal from './ExportModal';
import ConnectedImportModal from './ImportModal';

// Export for anyone who can read machines; Import only for roles that can
// update them, the same roles that can rename a machine one at a time.
function MachineCsvToolbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(null);
  const openExport = useCallback(() => setOpen('export'), []);
  const openImport = useCallback(() => setOpen('import'), []);
  const close = useCallback(() => setOpen(null), []);

  return (
    <>
      <RBAC
        resource={mapComponentToResource.Machines}
        operation={operations.Read}
        yes={(
          <GhostBtn type="button" onClick={openExport} title={t('assets.csv.export.tooltip', { defaultValue: 'Export assets as CSV' })}>
            <Download />
            {t('assets.csv.export.button', { defaultValue: 'Export' })}
          </GhostBtn>
        )}
      />
      <RBAC
        resource={mapComponentToResource.Machines}
        operation={operations.Update}
        yes={(
          <GhostBtn type="button" onClick={openImport} title={t('assets.csv.import.tooltip', { defaultValue: 'Import asset changes from a CSV' })}>
            <UploadIcon />
            {t('assets.csv.import.button', { defaultValue: 'Import' })}
          </GhostBtn>
        )}
      />
      {open === 'export' && <ConnectedExportModal close={close} />}
      {open === 'import' && <ConnectedImportModal close={close} openExport={openExport} />}
    </>
  );
}

MachineCsvToolbar.propTypes = {};

export default MachineCsvToolbar;
